// extracted by mini-css-extract-plugin
module.exports = {"label":"Tooltip_label__GFTcc"};